// The two editions, Day (hand-tinted chart on parchment) and Night (stained glass), as numbers the shaders
// can blend between. The palette is the one the first viewer was painted in.

export type Rgb = readonly [r: number, g: number, b: number];

const hex = (h: string): Rgb => {
  const n = parseInt(h.slice(1), 16);
  return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
};

export interface Edition {
  paper: Rgb;
  paperDeep: Rgb;
  ink: Rgb;
  inkSoft: Rgb;
  /** The thin line of paper left between two washes. */
  gap: Rgb;
  /** Darker pigment where a wash pools at its edge. */
  pool: Rgb;
  pigments: readonly Rgb[];
}

export const DAY: Edition = {
  paper: hex("#f2e8d3"),
  paperDeep: hex("#e9dcc0"),
  ink: hex("#2a2016"),
  inkSoft: hex("#6d5b45"),
  gap: hex("#f2e8d3"),
  pool: hex("#3b1d08"),
  pigments: [
    "#e1b262",
    "#d5765c",
    "#a6bd8f",
    "#8faac6",
    "#e4b1a3",
    "#8a90bf",
    "#c9bc72",
    "#cb8f63",
    "#bca8cb",
    "#9fc8b7",
  ].map(hex),
};

export const NIGHT: Edition = {
  paper: hex("#0f1117"),
  paperDeep: hex("#171a23"),
  ink: hex("#efe3c8"),
  inkSoft: hex("#a99e88"),
  gap: hex("#06070a"),
  pool: hex("#000000"),
  pigments: [
    "#c98a2e",
    "#b23a3a",
    "#2e8a5f",
    "#2f5fa8",
    "#b24f6e",
    "#6a4aa3",
    "#a88d2c",
    "#c4623c",
    "#7c8a2e",
    "#23898a",
  ].map(hex),
};

export const FONTS = {
  text: '"EB Garamond", Georgia, serif',
  display: '"IM Fell English", Georgia, serif',
  displaySc: '"IM Fell English SC", "IM Fell English", Georgia, serif',
} as const;
